var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { P, Debounce, CustomElement, Watch, Utils, PropertyConverters, PacemEventTarget } from '@pacem/pacem-core';
//namespace Pacem.Components.UI {
let PacemInfiniteScrollerElement = class PacemInfiniteScrollerElement extends PacemEventTarget {
    constructor() {
        super();
        this._scrollDelegate = () => this._doScroll();
        this._enabled = true;
        this._viewportHeight = 0;
        this._innerHeight = 0;
        this._isDocument = false;
        this._container = null;
        this._viewport = null;
        this._scroller = null;
        this._bottomGap = 10;
        this._container = this;
        this._viewport = this;
        this._scroller = this;
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this.setInfiniteScrollContainer(this._container);
    }
    disconnectedCallback() {
        if (!Utils.isNull(this._scroller))
            this._scroller.removeEventListener('scroll', this._scrollDelegate, false);
        super.disconnectedCallback();
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        switch (name) {
            case 'container':
                this.setInfiniteScrollContainer(val);
                break;
            case 'disabled':
                if (this._enabled = !val)
                    this._doScroll();
                break;
            case 'threshold':
                this._bottomGap = val || 0;
                break;
        }
    }
    setInfiniteScrollContainer(v = '$document') {
        var cont = v;
        var isDoc = this._isDocument = cont === '$document' || cont === document.body || cont === document.documentElement;
        this._container = isDoc ? (document.body || document.documentElement) : ((typeof v === 'string') ?
            document.querySelector(cont)
            :
                cont);
        this._viewport = isDoc ? window : this._container;
        if (this._scroller)
            this._scroller.removeEventListener('scroll', this._scrollDelegate, false);
        this._scroller = isDoc ? window.document : this._container;
        this._scroller.addEventListener('scroll', this._scrollDelegate, false);
        if (this._enabled)
            this._doScroll();
    }
    //ngOnChanges(changes: SimpleChanges) {
    //}
    _emitFetchMore() {
        /**
         * on-fetchmore => must toggle `enabled` while fetching...
         */
        var evt = new CustomEvent('fetchmore');
        this.dispatchEvent(evt);
    }
    _doScroll() {
        if (!this._enabled)
            return;
        if (!this._computeHeight()) {
            var scrollTop = this._scroller instanceof Document ? window.pageYOffset : this._scroller.scrollTop;
            var viewportHeight = this._viewportHeight, innerHeight = this._innerHeight;
            var threshold = innerHeight - (scrollTop + viewportHeight);
            if (threshold < this._bottomGap /* pixels */
                || innerHeight <= viewportHeight) {
                // fire fetchMore() 
                this._emitFetchMore();
                window.requestAnimationFrame(() => {
                    if (this._enabled)
                        this._doScroll();
                });
            } //else computeHeight();
        }
        else
            this._doScroll();
    }
    _computeHeight() {
        if (!this._container)
            return;
        var cont = this._container;
        var topOffset = Number.MAX_VALUE, bottomOffset = 0, totalHeight = 0, _innerHeight;
        if (this._isDocument) {
            var d = cont;
            _innerHeight = Math.max(d.scrollHeight, d.offsetHeight, d.clientHeight);
        }
        else {
            for (var i = 0; i < cont.children.length; i++) {
                var e = cont.children.item(i);
                var eTopOffset = e.offsetTop, eHeight = e.offsetHeight, eBottomOffset = eTopOffset + eHeight;
                totalHeight += eHeight;
                if (eTopOffset < topOffset) {
                    topOffset = eTopOffset;
                }
                if (eBottomOffset > bottomOffset) {
                    bottomOffset = eBottomOffset;
                }
            }
            _innerHeight = Math.round(bottomOffset - topOffset);
        }
        var _viewportHeight = this._viewport instanceof Window ? Utils.windowSize.height : this._viewport.offsetHeight;
        if (_innerHeight != this._innerHeight || _viewportHeight != this._viewportHeight) {
            this._innerHeight = _innerHeight;
            this._viewportHeight = _viewportHeight;
            return true;
        }
        return false;
    }
};
__decorate([
    Watch({ converter: PropertyConverters.String })
], PacemInfiniteScrollerElement.prototype, "container", void 0);
__decorate([
    Watch({ reflectBack: true, converter: PropertyConverters.Number })
], PacemInfiniteScrollerElement.prototype, "threshold", void 0);
__decorate([
    Debounce(100)
], PacemInfiniteScrollerElement.prototype, "_doScroll", null);
PacemInfiniteScrollerElement = __decorate([
    CustomElement({ tagName: P + '-infinite-scroller' })
], PacemInfiniteScrollerElement);
export { PacemInfiniteScrollerElement };
